import React from 'react';
import { useLocation } from 'react-router-dom';

import PageContent from 'components/PageContent';
import { CurrencyAverageTable } from 'components/CurrencyAverageTable';
import CurrencyConverter from 'components/CurrencyConverter';
import BanksTable from 'components/BanksTable';
import ExchangeDiscussion from 'components/ExchangeDiscussion';
import NewsSlider from 'components/NewsSlider';
import CurrencyNews from 'components/CurrencyNews';
import Banner from 'components/Banner';
import { NUMBER_OFF_ALL_ORGANIZATIONS } from 'constants/organizations';

const BanksPageContent = () => {
  const location = useLocation();
  const pageName = location.pathname.split('/')[1];

  return (
    <PageContent>
      <CurrencyAverageTable pageName={pageName} />
      <CurrencyConverter />
      <Banner id="hp-react-banner-content-1" slot="bn-slot-content-1" />
      <BanksTable quantity={NUMBER_OFF_ALL_ORGANIZATIONS} isClientNavigation />
      <ExchangeDiscussion />
      <NewsSlider />
      <CurrencyNews />
    </PageContent>
  );
};

export default BanksPageContent;
